import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const END_POINT = '/booking-reviews/global';

export default {
  async getManagerReviews(payload) {
    const params = getParamsFormObject(payload);
    const path = END_POINT + params;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
